import classNames from "classnames";

/**
 * Merge class names (shadcn-style helper). Uses `classnames` already in the project.
 * For full Tailwind class conflict resolution, add `tailwind-merge` + `clsx` later.
 */
export function cn(...inputs) {
  return classNames(inputs);
}
